
import { MY_PROFILE_DETAIL, MY_PROFILE_SALON_UPDATE, MY_PROFILE_UPDATE, SALON_DETAIL } from "../Constants/MyProfileConstants";
import { createGetDataReducer } from "./CommonReducer";

const MyProfileDetailReducer = createGetDataReducer(MY_PROFILE_DETAIL);
const MyProfileUpdateReducer = createGetDataReducer(MY_PROFILE_UPDATE);
const SalonDetailReducer = createGetDataReducer(SALON_DETAIL);
const SalonUpdateReducer = createGetDataReducer(MY_PROFILE_SALON_UPDATE);

export const MyProfileReducers = {
    MyProfileDetailState: MyProfileDetailReducer,
    MyProfileUpdateState: MyProfileUpdateReducer,
    SalonDetailState: SalonDetailReducer,
    SalonUpdateState:SalonUpdateReducer

}